import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const token = localStorage.getItem("token");
  return token ? <Component {...rest}><Outlet /></Component> : <Navigate to="/login" />;
};

export default ProtectedRoute;
